import { LoyaltyTiers } from '../constants/loyaltyTiers';

const orderedTiers = [
  LoyaltyTiers.GOLD,
  LoyaltyTiers.PLATINUM,
  LoyaltyTiers.BLACK,
];

/* this function assumes that the item has a loyalty restriction that requires
    testing.  It thus will return a conservative true if any bad data is passed
    in.
*/
export function isLockedToMember(memberTier, itemTier) {
  const memberIndex = orderedTiers.findIndex((x) => x === memberTier);
  const itemIndex = orderedTiers.findIndex((x) => x === itemTier);

  return !(memberIndex >= 0 && itemIndex >= 0 && memberIndex >= itemIndex);
}

/* This function is to determine whether the member is on the new loyalty program.
    Since the Gold tier label is also present in the old program, we determine the 
    member is in the new program by verifying they are on the 1st tier in the 
    plan list.
*/
export function isOnNewLoyaltyProgram(memberTier, loyaltyPlans) {
  return (
    (memberTier?.label === LoyaltyTiers.GOLD &&
      memberTier?.membershipRewardTierId ===
        loyaltyPlans.tiers[0]?.membershipRewardTierId) ||
    [LoyaltyTiers.PLATINUM, LoyaltyTiers.BLACK].includes(memberTier?.label)
  );
}
